import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatBalance, formatLastActive } from '@/lib/member-display'
import type { MemberDetail } from '@riverpark/types'
import { formatMemberSince } from './profile-utils'

interface ProfileOverviewPanelProps {
  profile: MemberDetail
  isSelf: boolean
}

export function ProfileOverviewPanel({ profile, isSelf }: ProfileOverviewPanelProps) {
  const balance = formatBalance(profile.outstandingBalance)

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Account summary</CardTitle>
        </CardHeader>
        <CardContent>
          <dl className="grid gap-4 sm:grid-cols-2">
            <div className="rounded border border-border-2 bg-cream-2/30 px-4 py-3">
              <dt className="font-sans text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
                Billing status
              </dt>
              <dd className={`mt-1 font-serif text-xl ${balance.className}`}>{balance.label}</dd>
            </div>
            <div className="rounded border border-border-2 bg-cream-2/30 px-4 py-3">
              <dt className="font-sans text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
                Member since
              </dt>
              <dd className="mt-1 font-sans text-sm text-ink">
                {formatMemberSince(profile.createdAt)}
              </dd>
            </div>
            <div className="rounded border border-border-2 bg-cream-2/30 px-4 py-3">
              <dt className="font-sans text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
                Last sign-in
              </dt>
              <dd className="mt-1 font-sans text-sm text-ink">
                {formatLastActive(profile.lastLoginAt)}
              </dd>
            </div>
            {profile.role !== 'admin' && (
              <div className="rounded border border-border-2 bg-cream-2/30 px-4 py-3">
                <dt className="font-sans text-[11px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
                  Plot assignments
                </dt>
                <dd className="mt-1 font-sans text-sm text-ink">
                  {profile.plots.length === 0
                    ? 'None assigned'
                    : `${profile.plots.length} plot${profile.plots.length > 1 ? 's' : ''}`}
                </dd>
              </div>
            )}
          </dl>
          {!isSelf && (
            <p className="mt-4 font-sans text-xs leading-relaxed text-muted-foreground">
              Plot assignments and billing are managed by the estate office. Contact changes save
              from the Manage tab.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
